import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import './ShowProduct.css';
import { Server_URL } from "../config.js";

function ShowTouchDetail() {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  // console.log("get into ShowTouchDetail id : ", id);
  useEffect(() => {
    axios
      .get(`${Server_URL}/get_touch/${id}`)
      // .get(`http://localhost:3022/get_touch/${id}`)
      // .get(`http://localhost:5000/get_touch/${id}`)
      .then((res) => { setData(res.data); })
      .catch((err) => console.log(err));
  }, [id]);

  return (
    <div className='container-fluid vw-100 vh-100 bg-primary-subtle'>
      <h1>Touch SNo : {id}</h1>
      <button className='btn btn-success m-1' onClick={() => navigate(-1)}>Back</button>
      {/* <Link to="/CRUDTouchs" className='btn btn-success'>Back</Link> */}
      {data.map((touch, i) => {
        return (
          <ul className='list-group' key={i++}>
            <ul className='list-group list-group-horizontal'>
              <li className='list-group-item bg-warning-subtle m-1'> SNo : <ins>{touch["SNo"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> Size : <ins>{touch["Size"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> PartNo : <ins>{touch["PartNo"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> Ratio : <ins>{touch["Ratio"]}</ins> </li>
            </ul>
            <br/>
            <ul className='list-group list-group-horizontal'>
              <li className='list-group-item bg-warning-subtle m-1'> CoverOD : <ins>{touch["CoverOD"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> LcmAA : <ins>{touch["LcmAA"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> CoverVA : <ins>{touch["CoverVA"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> CoverThick : <ins>{touch["CoverThick"]}</ins> </li>
            </ul>
            <br/>
            <ul className='list-group list-group-horizontal'>
              <li className='list-group-item bg-warning-subtle m-1'> SensorOD : <ins>{touch["SensorOD"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> SensorAA : <ins>{touch["SensorAA"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> SensorThick : <ins>{touch["SensorThick"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> ChannelRxTx : <ins> {touch["ChannelRxTx"]}</ins> </li>
            </ul>
            <br/>
            <ul className='list-group list-group-horizontal'>
              <li className='list-group-item bg-warning-subtle m-1'> ControlIC : <ins>{touch["ControlIC"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> CGParam : <ins>{touch["CGParam"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> SensorPN : <ins>{touch["SensorPN"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> CustomerPN : <ins>{touch["CustomerPN"]}</ins> </li>
            </ul>
            <br/>
            <ul className='list-group list-group-horizontal'>
              <li className='list-group-item bg-warning-subtle m-1'> ConnectorType : <ins>{touch["ConnectorTypex"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> FpcType : <ins>{touch["FpcType"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> FWConfig : <ins>{touch["FWConfig"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> FWDownload : <ins>{touch["FWDownload"]}</ins> </li>
            </ul>
            <br/>
            <ul className='list-group list-group-horizontal'>
              <li className='list-group-item bg-warning-subtle m-1'> FWUpgrade : <ins>{touch["FWUpgrade"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> FWVersion : <ins>{touch["FWVersion"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> Resolution : <ins>{touch["Resolution"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> Original : <ins>{touch["Original"]}</ins> </li>
            </ul>
            <br/>
            <ul className='list-group list-group-horizontal'>
              <li className='list-group-item bg-warning-subtle m-1'> TestBoard : <ins>{touch["TestBoard"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> TestDate : <ins>{touch["TestDate"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> RegistDate : <ins>{touch["RegistDate"]}</ins> </li>
              <li className='list-group-item bg-warning-subtle m-1'> Note : <ins>{touch["Note"]}</ins> </li>
            </ul>
          </ul>
        );
      })}
    </div>
  );
}

export default ShowTouchDetail;
